import { createAsyncThunk } from '@reduxjs/toolkit';
import { HOST_URL } from 'config';
import { GroupHeader, GroupSettingsProfiles } from 'pages/settings/sections/groups/types';
import axiosInstance from 'utils/axios';

export interface Profile {
  Id: number;
  Name: string;
}

export interface AntivirusProfile extends Profile {
  Created: Date;
  Description: string;
  TriggerName: string;
  TriggerType: number;
  Updated: Date;
}

export interface GlobalSettings {
  IsEpsUninstallPasswordDefinedGlobally: boolean;
  EpsUninstallPasswordMinLength: number;
  EnableWEProfiles: boolean;
}

export const initGroupProfiles = createAsyncThunk('groupSettings/initGroupProfiles', async (groupId: string) => {
  return (await axiosInstance.get(`${HOST_URL}/WebApp/GroupSettings/GetProfilesByGroupId?id=${groupId}`))
    .data as GroupSettingsProfiles;
});

export const initAntivirusScheduleProfiles = createAsyncThunk('groupSettings/initAntivirusProfiles', async () => {
  return (await axiosInstance.get(`${HOST_URL}/WebApp/antivirus-profiles`)).data as AntivirusProfile[];
});

export const initFileMonitorProfiles = createAsyncThunk('groupSettings/initFileMonitorProfiles', async () => {
  return (await axiosInstance.get(`${HOST_URL}/WebApp/SettingsFileMonitor/GetFileMonitorProfiles`)).data as Profile[];
});

export const initStorageDevicesProfiles = createAsyncThunk('groupSettings/initStorageDevicesProfiles', async () => {
  return (await axiosInstance.get(`${HOST_URL}/WebApp/StorageDevicesProfile/GetStorageDevicesProfilesV2`))
    .data as Profile[];
});

export const initWindowsEventsProfiles = createAsyncThunk('groupSettings/initWindowsEventsProfiles', async () => {
  return (await axiosInstance.get(`${HOST_URL}/WebApp/WindowsEventsProfile/GetWindowsEventsProfilesV2`))
    .data as Profile[];
});

export const initGroupsWithSamePlatform = createAsyncThunk(
  'groupSettings/initGroupsWithSamePlatform',
  async (args: { groupId: string; platformType: string }) => {
    const { groupId, platformType } = args;
    const url = `${HOST_URL}/WebApp/GroupSettings/GetGroupsWithSamePlatformByGroupId?groupId=${groupId}${
      platformType ? `&platformType=${platformType}` : ''
    }`;
    return (await axiosInstance.get(url)).data as GroupHeader[];
  }
);

export const initGlobalSettings = createAsyncThunk('groupSettings/initGlobalSettings', async () => {
  return (await axiosInstance.get(`${HOST_URL}/WebApp/Settings/GetGlobalSettings`)).data as GlobalSettings;
});
